import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const ContainerImg = styled('div')`
  cursor: pointer;
  display: inline-block;
  height: ${props => props.height};
  padding: 0 8px;
  position: relative;
  text-align: ${props => props.textalign};
  width: ${props => props.width};
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`

export const SectionHeaderContainer = styled('section')`
  background-color: ${props => props.theme.palette.blue[20]};
  display: flex;
  height: ${props => props.height};
  margin: ${props => props.margin};
  width: 100%;
`

export const GridContainer = styled(({ margin, minHeight, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    min-height: ${props => props.minHeight};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const HeaderText = styled('p')`
  color: ${props => props.theme.palette.blue[75]};
  font-weight: 700;
  font-size: 18px;
  margin: ${props => props.margin};
  line-height: 21px;
`

export const Image = styled('img')`
  border-radius: 12px;
  height: 100%;
  object-fit: cover;
  width: 100%;
`

export const Overlay = styled('div')`
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 48.79%, rgba(0, 0, 0, 0) 82.45%);
  border-radius: 12px;
  height: 100%;
  position: absolute;
  transform: rotate(-90deg);
  top: 0;
  width: 99%;
`

export const Root = styled('div')`
  width: 100%;
`

export const TextImg = styled('p')`
  color: ${props => props.theme.palette.brand.white};
  font-weight: 700;
  font-size: ${props => props.fontSize};
  left: ${props => props.left};
  line-height: 28px;
  position: absolute;
  top: ${props => props.top};
  transform: translate(-50%, -50%);
`
